(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-size-guide-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('famiware-size-guide')) {
    customElements.define('famiware-size-guide', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const trigger = this.querySelector('[data-size-guide-open]');
        const dialog = this.querySelector('dialog');
        if (!trigger || !dialog || typeof dialog.showModal !== 'function') return;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', dialog.id);
        trigger.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const image = this.querySelector('[data-size-guide-image]');
          if (image) {
            this.querySelector('[data-size-guide-body]').append(image.content.cloneNode(true));
            image.remove();
          }
          if (!dialog.open) dialog.showModal();
        }, options);
        this.querySelector('[data-size-guide-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const controls = Array.from(dialog.querySelectorAll('button, a[href]')).filter(control => control.getClientRects().length);
          const first = controls[0];
          const last = controls[controls.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }, options);
        let startedOnBackdrop = false;
        const outside = (event) => {
          const bounds = dialog.getBoundingClientRect();
          return event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
        };
        dialog.addEventListener('pointerdown', (event) => { startedOnBackdrop = outside(event); }, options);
        dialog.addEventListener('click', (event) => {
          if (startedOnBackdrop && outside(event)) dialog.close();
          startedOnBackdrop = false;
        }, options);
        dialog.addEventListener('close', () => {
          if (trigger.isConnected) trigger.focus({ preventScroll: true });
        }, options);
      }
      disconnectedCallback() {
        const dialog = this.querySelector('dialog');
        if (dialog?.open) dialog.close();
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["star-product-services"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('star-product-services')) {
    customElements.define('star-product-services', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.addEventListener('click', event => {
          const trigger = event.target.closest('[data-star-open]');
          if (trigger && this.contains(trigger)) {
            const dialog = document.getElementById(trigger.dataset.starOpen);
            if (!dialog || !this.contains(dialog)) return;
            this.querySelectorAll('dialog[open]').forEach(item => item.close());
            this.returnFocus = trigger;
            dialog.showModal();
          }
          const close = event.target.closest('[data-star-close]');
          if (close && this.contains(close)) close.closest('dialog').close();
          if (event.target instanceof HTMLDialogElement) {
            const rect = event.target.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
          }
        }, options);
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('close', () => this.returnFocus?.focus({ preventScroll: true }), options);
        });
      }
      disconnectedCallback() {
        this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
        this.events?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
